<template>
    <div class="A4">
        <div class="row">
            <div class="col-sm-12">
                <div class="print-header">
                    <h4 class="text-center font-m">{{$t('expense_on_sale_return')}}</h4>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <table class="table table-bordered table-sm table-striped no-bor">
                    <thead>
                        <tr>
                            <th style="width: 50px;" class="text-center">{{$t('no')}}</th>
                            <th>{{$t('code')}}</th>
                            <th>{{$t('date')}}</th>
                            <th class="sorting">{{$t('customer')}}</th>
                            <th>{{$t('sale_reputation')}}</th>
                            <th>{{$t('delivery_to_branch')}}</th>
                            <th>{{$t('ref_num')}}</th>
                            <th style="width: 150px;">{{$t('total_amount')}}</th>
                            <th style="width: 150px;">{{$t('discount')}}</th>
                            <th class="text-right" style="width: 150px;">{{$t('paid_amount')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{ret.Num}}</td>
                            <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                            <td>{{ret.CustomerName}}</td>
                            <td>{{ret.EmployeeName}}</td>
                            <td>{{ret.BranchName}}</td>
                            <td>{{ret.RefNum}}</td>
                            <td class="text-right">{{$money(ret.TotalAmount)}}</td>
                            <td class="text-right">{{$money(ret.Discount)}}</td>
                            <td class="text-right">{{$money(ret.PaidAmount)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="9" class="text-right">{{$t('total')}}</th>
                            <th class="text-right">{{$money(totalAmount)}}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                query:{
                    Year: new Date().getFullYear(),
                    Month: new Date().getMonth() + 1
                },
                records:[]
            }
        },
        created: function(){
            let linkQuery = this.$route.query;
            if(linkQuery.year != undefined && linkQuery.year != null && linkQuery.year != ''){
                this.query.Year = linkQuery.year;
            }
            if(linkQuery.month != undefined && linkQuery.month != null && linkQuery.month != ''){
                this.query.Month = linkQuery.month;
            }
            this.toList();
        },
        methods: {
            toList(){
                var loading = this.$loading.show();
                    this.$api().post('report/expense/returns', this.query).then(res => {
                    if(this.$isValid(res)){
                        this.records = res.data.Json.Exchanges;
                    }
                }).finally(() => { loading.hide(); });
            }
        },
        computed: {
            totalAmount(){
                let total = 0;
                this.records.map(el=>{
                    total += el.PaidAmount;
                });
                return total;
            }
        }
    }
</script>